import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["shape", "size", "label"];
import React from 'react';
import Dots from '../shapes/Dots/Dots';
import Bar from '../shapes/Bar/Bar';
/**
 * A component to show loading state
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
const Activity = function (props) {
  const shape = props.shape,
    size = props.size,
    label = props.label,
    html = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shape === 'dots' && /*#__PURE__*/React.createElement(Dots, _extends({
    size: size
  }, html)), shape === 'bar' && /*#__PURE__*/React.createElement(Bar, _extends({
    doesLoop: true,
    label: label
  }, html)));
};
export default Activity;
//# sourceMappingURL=Activity.js.map